import { render, staticRenderFns } from "./DefaultData.vue?vue&type=template&id=3f9ac5ad&scoped=true"
import script from "./DefaultData.vue?vue&type=script&lang=js"
export * from "./DefaultData.vue?vue&type=script&lang=js"
import style0 from "./DefaultData.vue?vue&type=style&index=0&id=3f9ac5ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f9ac5ad",
  null
  
)

export default component.exports